import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateRegEdSubmissions } from './useRegEdSubmissionsQuery';

/** A plain reschedule leaves a held post `Pending`. */
export const useRegEdSocialPostReleaseMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (post: Api.ISocialMediaPost) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			postId,
			dueDate,
			impersonationContext,
		}: {
			postId: string;
			dueDate?: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<Api.ISocialMediaPost>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'social/post/releaseConditionalHold',
				}),
				'POST',
				{ postId, dueDate }
			),
		onError,
		onSuccess: (post, { postId }) => {
			invalidateRegEdSubmissions(postId);
			onSuccess?.(post);
		},
	});
};
